import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { useAuth } from '../services/AuthProvider';
import { Spinner } from 'react-bootstrap';
import { logo } from '../pdf/Imges';
import { Lock, Person } from 'react-bootstrap-icons';

function Login() {

    const [waiting, setWaiting] = useState(false);
    const auth = useAuth();

    const navigate = useNavigate()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')

    const usernameHandler = (event) => {
        setUsername(event.target.value)
    }

    const passwordHandler = (event) => {
        setPassword(event.target.value)
    }

    const submitHandler = async (event) => {
        event.preventDefault();
        setWaiting(true)
        try {
            await auth.loginRequest({ username: username, password: password })
        } catch (error) {
            alert("Echec Authentification...")
        }
        finally {
            setWaiting(false);
        }
    }

    return (
        <div className='d-flex align-items-center justify-content-center' style={{ backgroundColor: 'Window', position: 'absolute', minWidth: '100%', minHeight: '100%' }}>
            <div>
                <div className='text-center mb-5'>
                    <img src={logo} width={200} />
                </div>
                <div className='card card-body shadow'>
                    <form className="login-form" onSubmit={submitHandler} style={{ width: '40rem' }}>
                        <h2 className='text-center text-muted mb-4'>Connexion</h2>
                        <div className='input-group mb-2'>
                            <span className='input-group-text'>
                                <Person />
                            </span>
                            <input className='form-control' type="text" value={username} onChange={usernameHandler} placeholder='Username' required />
                        </div>
                        <div className='input-group mb-2'>
                            <span className='input-group-text'>
                                <Lock />
                            </span>
                            <input className='form-control' type="password" value={password} onChange={passwordHandler} placeholder='Password' required />
                        </div>
                        <div className='form-group text-center'>
                            <button type='submit' className='btn btn-success' disabled={waiting}>
                                {waiting ? <Spinner /> : "Se connecter"}
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    )
}

export default Login